/* Publish by EComposer at 2025-08-11 08:45:51*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kyzub6atcc"]=  window.__ectimmers["ecom-kyzub6atcc"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-kyzub6atcc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyzub6atcc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yolhry0avsc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yolhry0avsc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2jipkc3bhg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2jipkc3bhg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9dbr5ccow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9dbr5ccow', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2tkqa4r86v9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2tkqa4r86v9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijnknlf8dsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijnknlf8dsn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9bh5yx71ijm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9bh5yx71ijm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ziyjib35ovh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ziyjib35ovh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c9d5h9fnr2g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c9d5h9fnr2g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mikzvva6r3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mikzvva6r3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-31ds4gy9xi2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-31ds4gy9xi2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1kv51u6pdqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1kv51u6pdqq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uphywa8oc2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uphywa8oc2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bgtrmqagr8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bgtrmqagr8i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y51abdv04jr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y51abdv04jr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kdast1j4qs9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kdast1j4qs9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7sz3mk49dq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7sz3mk49dq8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4kf92zy26g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4kf92zy26g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-emn3un7lpos').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emn3un7lpos', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jyd2t9hcgw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jyd2t9hcgw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hv93hfrld8q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hv93hfrld8q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2emlhn7h169').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2emlhn7h169', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zlatgy21xcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zlatgy21xcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qoc7d1cqu8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qoc7d1cqu8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bw6y2wv2lrc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bw6y2wv2lrc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-41eaoo2v39t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-41eaoo2v39t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bzpirkmgqxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bzpirkmgqxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2975hk4ou2y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2975hk4ou2y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izh5i8vvee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izh5i8vvee', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d9hxks2ugcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d9hxks2ugcr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qnmzcsuivu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qnmzcsuivu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lk5deh6d1f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lk5deh6d1f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4yso9wsjtq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4yso9wsjtq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xgv1xh8yzs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xgv1xh8yzs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ioceak52r0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ioceak52r0q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3fsjpd7urol').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3fsjpd7urol', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4zbj316asq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4zbj316asq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c3zofql78vj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c3zofql78vj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gd8kwgo0qim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gd8kwgo0qim', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ll1bbg5yp1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll1bbg5yp1e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wfpb7v6cve').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wfpb7v6cve', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ntzi70hovl7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ntzi70hovl7', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e9fyemj05t"]=  window.__ectimmers["ecom-e9fyemj05t"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-e9fyemj05t"]["ngyu04ojq"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-e9fyemj05t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e9fyemj05t', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y0m8nr9318n"]=  window.__ectimmers["ecom-y0m8nr9318n"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-y0m8nr9318n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0m8nr9318n', settings: {"link":"lightbox","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5brp7ro1gt"]=  window.__ectimmers["ecom-5brp7ro1gt"] || {};
if(!this.settings||!this.$el||this.isLive)return;const e=this.$el;let i=e.querySelectorAll('script:not([type="application/json"])');i.length>0&&i.forEach(function(t){let n=document.createElement("script");n.type="text/javascript",n.innerText=t.innerText,t.src&&(n.src=t.src),e.appendChild(n),t.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-5brp7ro1gt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5brp7ro1gt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-39cqkj6poen').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-39cqkj6poen', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4tgeyhzulwm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4tgeyhzulwm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m7lkjwsxdo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m7lkjwsxdo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gby3t3ypo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gby3t3ypo9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-as372yqdtns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-as372yqdtns', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9lr38oku5yv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lr38oku5yv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pgxenp6tq8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgxenp6tq8m', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}